import * as React from 'react';
import {Query, Mutation} from 'react-apollo';
// @ts-expect-error
import type {DataProxy} from 'react-apollo';

import {Button} from 'shells/button/button';
import {IconButton} from 'shells/button/icon-button/icon-button';
import {IconOnlyButton} from 'shells/button/icon-only-button/icon-only-button';
import {ShareIcon} from 'shells/icon';
import {ShareArrowRegularIcon} from 'shells/icon/svg/share-arrow-regular-icon';

import type {
    PeepSendToDestinations as PeepSendToDestinationsFragment,
    GetPeepSendToDestinations as GetPeepSendToDestinationsQuery,
    GetPeepSendToDestinationsVariables as GetPeepSendToDestinationsQueryVariables,
    AddEntityToConstantContact as AddEntityToConstantContactMutation,
    AddEntityToConstantContactVariables as AddEntityToConstantContactMutationVariables,
    QuickbooksCreateOrUpdateCustomer,
    QuickbooksCreateOrUpdateCustomerVariables,
    GetCtctContacts as GetCtctContactsQuery,
} from 'nutshell-graphql-types';

import {ConstantContactPopover} from '../core/constant-contact/constant-contact-popover/constant-contact-popover';
import {GetSessionUser} from '../core/get-session-user';
import {QuickbooksPeepPopover} from '../core/quickbooks/quickbooks-peep-popover';
import ADD_ENTITY_TO_CONSTANT_CONTACT from '../peep/constant-contact/graphql/mutations/add-entity-to-constant-contact.graphql';
import GET_CTCT_CONTACTS from '../peep/constant-contact/graphql/queries/get-ctct-contacts.graphql';
import ADD_PEEP_TO_QUICKBOOKS from '../peep/quickbooks/graphql/mutations/add-peep-to-quickbooks.graphql';

import GET_PEEP_SEND_TO_DESTINATIONS_QUERY from './graphql/queries/get-peep-send-to-destinations.graphql';
import {PeepActionMenu} from './peep-action-menu';

import styles from './peep-send-to.module.css';

type OwnProps = {
    peepId: string;
    iconOnly?: boolean;
};

type Props = OwnProps & {
    peep: PeepSendToDestinationsFragment | null | undefined;
};

type State = {
    showingSendToMenu: boolean;
    showingConstantContactPopover: boolean;
    showingQuickbooksPopover: boolean;
};

class AddPersonToCtCtMutation extends Mutation<
    AddEntityToConstantContactMutation,
    AddEntityToConstantContactMutationVariables
> {}

class QuickbooksCreateOrUpdateCustomerMutation extends Mutation<
    QuickbooksCreateOrUpdateCustomer,
    QuickbooksCreateOrUpdateCustomerVariables
> {}

export class PeepSendToComponent extends React.PureComponent<Props, State> {
    buttonRef: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            showingSendToMenu: false,
            showingConstantContactPopover: false,
            showingQuickbooksPopover: false,
        };
    }

    render() {
        return (
            <AddPersonToCtCtMutation mutation={ADD_ENTITY_TO_CONSTANT_CONTACT}>
                {(addEntityToConstantContact) => (
                    <QuickbooksCreateOrUpdateCustomerMutation mutation={ADD_PEEP_TO_QUICKBOOKS}>
                        {(quickbooksCreateOrUpdateCustomer) => (
                            <GetSessionUser>
                                {({user}) => (
                                    <div
                                        className={
                                            NutClientConfig.hasPeepPagesRedesignFF
                                                ? undefined
                                                : styles.container
                                        }
                                    >
                                        {NutClientConfig.hasPeepPagesRedesignFF &&
                                        this.props.iconOnly ? (
                                            <IconOnlyButton
                                                icon={ShareArrowRegularIcon}
                                                onClick={() => {
                                                    this.setState({
                                                        showingSendToMenu: true,
                                                    });
                                                }}
                                                getButtonRef={(node: HTMLElement) => {
                                                    this.buttonRef = node;
                                                }}
                                                isDisabled={!this.props.peep}
                                                size='large'
                                                tooltipText='Send to'
                                            />
                                        ) : NutClientConfig.hasPeepPagesRedesignFF ? (
                                            <IconButton
                                                icon={ShareArrowRegularIcon}
                                                size='normal'
                                                onClick={() => {
                                                    this.setState({
                                                        showingSendToMenu: true,
                                                    });
                                                }}
                                                text='Send to'
                                                getButtonRef={(node: HTMLElement) => {
                                                    this.buttonRef = node;
                                                }}
                                                isDisabled={!this.props.peep}
                                            />
                                        ) : (
                                            <Button
                                                // @ts-expect-error
                                                getButtonRef={(node) => {
                                                    this.buttonRef = node;
                                                }}
                                                variant='secondary'
                                                size='normal'
                                                onClick={() => {
                                                    this.setState({
                                                        showingSendToMenu: true,
                                                    });
                                                }}
                                                disabled={!this.props.peep}
                                            >
                                                <ShareIcon />
                                                Send to…
                                            </Button>
                                        )}
                                        {this.props.peep ? (
                                            <PeepActionMenu
                                                peep={this.props.peep}
                                                anchor={this.buttonRef}
                                                onClose={() => {
                                                    this.setState({
                                                        showingSendToMenu: false,
                                                    });
                                                }}
                                                onConstantContactSelected={this.showConstantContact}
                                                onQuickbooksSelected={this.showQuickbooks}
                                                // Handle opening the popover in the action menu, so we
                                                // always render it and fetch custom send-tos immediately
                                                isOpen={this.state.showingSendToMenu}
                                            />
                                        ) : undefined}
                                        {this.state.showingConstantContactPopover ? (
                                            <ConstantContactPopover
                                                anchor={this.buttonRef}
                                                submitButtonText='Send'
                                                canAccessIntegrations={Boolean(
                                                    user && user.permissions.canAccessSetup
                                                )}
                                                onCancel={() => {
                                                    this.setState({
                                                        showingConstantContactPopover: false,
                                                    });
                                                }}
                                                onSuccess={() => {
                                                    this.setState({
                                                        showingConstantContactPopover: false,
                                                    });
                                                    Popmini.open(
                                                        'Successfully sent to Constant Contact.',
                                                        {
                                                            attachTo: this.buttonRef,
                                                            classes: 'type-message',
                                                            orientation: 'east',
                                                        }
                                                    );
                                                }}
                                                onSubmit={(data) => {
                                                    // This should not happen, but makes flow happy.
                                                    if (!this.props.peep) {
                                                        return Promise.reject(
                                                            new Error(
                                                                'We weren’t able to export to Constant Contact.  Please try again.'
                                                            )
                                                        );
                                                    }

                                                    if (!data.listId) {
                                                        return Promise.reject(
                                                            'Choose a constant contact list.'
                                                        );
                                                    }

                                                    const entityId = this.props.peep.id;

                                                    return addEntityToConstantContact({
                                                        variables: {
                                                            input: {
                                                                entityId: entityId,
                                                                listId: data.listId,
                                                            },
                                                        },
                                                        update: (
                                                            proxy: DataProxy,
                                                            mutationResults
                                                        ) => {
                                                            const entity =
                                                                mutationResults &&
                                                                mutationResults.data &&
                                                                mutationResults.data
                                                                    .constantContactAddEntityToList
                                                                    .entity;
                                                            if (!entity) return;

                                                            const cacheResult:
                                                                | GetCtctContactsQuery
                                                                | null
                                                                | undefined = proxy.readQuery({
                                                                query: GET_CTCT_CONTACTS,
                                                                variables: {
                                                                    entityId: entityId,
                                                                },
                                                            });

                                                            if (!cacheResult) return;

                                                            const cachedContact =
                                                                cacheResult.coreEntity;

                                                            if (!cachedContact) return;

                                                            proxy.writeQuery({
                                                                query: GET_CTCT_CONTACTS,
                                                                variables: {
                                                                    entityId: entityId,
                                                                },
                                                                data: {
                                                                    coreEntity: {
                                                                        ...cachedContact,
                                                                        ...entity,
                                                                    },
                                                                },
                                                            });
                                                        },
                                                    });
                                                }}
                                            />
                                        ) : null}
                                        {this.state.showingQuickbooksPopover && this.props.peep ? (
                                            <QuickbooksPeepPopover
                                                anchor={this.buttonRef}
                                                peep={this.props.peep}
                                                canAccessIntegrations={Boolean(
                                                    user && user.permissions.canAccessSetup
                                                )}
                                                onCancel={() => {
                                                    this.setState({
                                                        showingQuickbooksPopover: false,
                                                    });
                                                }}
                                                onSuccess={() => {
                                                    this.setState({
                                                        showingQuickbooksPopover: false,
                                                    });
                                                }}
                                                onSubmit={() => {
                                                    // This should not happen, but makes flow happy.
                                                    if (!this.props.peep) {
                                                        return Promise.reject(
                                                            new Error(
                                                                'We weren’t able to send this person to Quickbooks.  Please try again.'
                                                            )
                                                        );
                                                    }

                                                    const peepId = this.props.peep.id;

                                                    return quickbooksCreateOrUpdateCustomer({
                                                        variables: {
                                                            input: {
                                                                peepId: peepId,
                                                            },
                                                        },
                                                    });
                                                }}
                                            />
                                        ) : null}
                                    </div>
                                )}
                            </GetSessionUser>
                        )}
                    </QuickbooksCreateOrUpdateCustomerMutation>
                )}
            </AddPersonToCtCtMutation>
        );
    }

    showConstantContact = () => {
        this.setState({showingConstantContactPopover: true});
    };

    showQuickbooks = () => {
        this.setState({showingQuickbooksPopover: true});
    };
}

class GetEntityQuery extends Query<
    GetPeepSendToDestinationsQuery,
    GetPeepSendToDestinationsQueryVariables
> {}

export const PeepSendTo = (props: OwnProps) => (
    <GetEntityQuery query={GET_PEEP_SEND_TO_DESTINATIONS_QUERY} variables={{id: props.peepId}}>
        {({data}) => {
            const peep = data && data.peep;

            return <PeepSendToComponent {...props} peep={peep} />;
        }}
    </GetEntityQuery>
);
